import React, { useContext } from 'react';
import { FloatingPortal } from '@floating-ui/react';
import PropTypes from 'prop-types';
import PopoverContext from '../../context';

const DropdownContent = ({ children = null }) => {
  const { isVisible, refs, floatingStyles, getFloatingProps, width, portalRootNode } =
    useContext(PopoverContext);

  if (!isVisible) {
    return null;
  }

  return (
    <FloatingPortal {...(portalRootNode && { root: portalRootNode })}>
      <div
        ref={refs.setFloating}
        className="ws-ui-dropdown-content"
        style={{ ...floatingStyles, width }}
        {...getFloatingProps()}
      >
        {children}
      </div>
    </FloatingPortal>
  );
};

DropdownContent.propTypes = {
  children: PropTypes.node,
};

export default DropdownContent;
